import { configureStore } from '@reduxjs/toolkit';
import adminSlice from './slices/admin-slice';
import authSlice from './slices/auth-slice';
import carHouseSlice from './slices/carHouse-slice';
import errorSlice from './slices/error-slice';
import carHouseAdminSlice from './slices/carHouseAdmin-slice';
import carHouseUserSlice from './slices/carHouseUser-slice';
import vehicleSlice from './slices/vehicles-slice';
import vehicleImageSlice from './slices/vehicleImages-slice';
import tagsSlice from './slices/tags-slice';
import makesSlice from './slices/vehicleMakes-slice';
import modelsSlice from './slices/vehicleModels-slice';
import generationsSlice from './slices/vehicleGenerations-slice';
import equipmentsSlice from './slices/vehicleEquipments-slice';
import subscriptionsAndCreditsSlice from './slices/subscriptionsAndCredits-slice';
import invoicesSlice from './slices/invoices-slice';
import logosSlice from './slices/logos-slice';
import carHouseLogosSlice from './slices/carHouseLogos-slice';
import carHouseVehiclesSlice from './slices/carHouseVehicles-slice';
import userVehiclesSlice from './slices/usersVehicles-slice';
import imageRequestsSlice from './slices/imageRequests-slice';

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    carHouse: carHouseSlice.reducer,
    error: errorSlice.reducer,
    admin: adminSlice.reducer,
    carHouseAdmin: carHouseAdminSlice.reducer,
    carHouseUser: carHouseUserSlice.reducer,
    vehicle: vehicleSlice.reducer,
    vehicleImage: vehicleImageSlice.reducer,
    tags: tagsSlice.reducer,
    makes: makesSlice.reducer,
    models: modelsSlice.reducer,
    generations: generationsSlice.reducer,
    equipments: equipmentsSlice.reducer,
    subscriptionsAndCredits: subscriptionsAndCreditsSlice.reducer,
    invoices: invoicesSlice.reducer,
    logos: logosSlice.reducer,
    carHouseLogos: carHouseLogosSlice.reducer,
    carHouseVehicles: carHouseVehiclesSlice.reducer,
    userVehicles: userVehiclesSlice.reducer,
    imageRequests: imageRequestsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable the serializable state invariant check
    }),
});

export default store;
